/* 只记录业务成功回执。复用已配置的官方 GA 标签，不加载第二套标签。 */
(function (factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else factory(window, document);
})(function installFormAnalytics(win, doc) {
  'use strict';
  if (win.__roomdenFormAnalyticsInstalled || win.Shopify?.designMode) return;
  win.__roomdenFormAnalyticsInstalled = true;
  const target = 'G-DFBCGLVJN2';
  const types = new Set(['newsletter', 'contact', 'business', 'return_request']);
  const prefix = 'roomden:form-receipt:v1:';
  const maxAge = 30 * 60 * 1000;
  const bound = new WeakSet();
  const markers = new Set();
  let timer = null;
  let attempts = 0;
  let privacyRequested = false;
  function ensurePrivacy() {
    if (typeof win.Shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function' || privacyRequested ||
        typeof win.Shopify?.loadFeatures !== 'function') return;
    privacyRequested = true;
    try {
      win.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
        if (!error && markers.size) start();
      });
    } catch (_) { /* 无法核对同意时不采集。 */ }
  }
  function allowed() {
    try {
      const privacy = win.Shopify?.customerPrivacy;
      return typeof privacy?.analyticsProcessingAllowed === 'function'
        ? privacy.analyticsProcessingAllowed() : null;
    } catch (_) { return null; }
  }
  function key(marker) { return prefix + marker.dataset.rdFormKey; }
  function remove(marker) {
    try { win.sessionStorage.removeItem(key(marker)); } catch (_) { /* 不影响表单。 */ }
  }
  function configured() {
    return typeof win.gtag === 'function' && Array.isArray(win.dataLayer) &&
      win.dataLayer.some(entry => entry && entry[0] === 'config' && entry[1] === target) &&
      win.dataLayer.some(entry => entry && entry[0] === 'event' && entry[1] === 'page_view' &&
        (entry[2]?.send_to === target || (Array.isArray(entry[2]?.send_to) && entry[2].send_to.includes(target))));
  }
  function receive(marker) {
    const consent = allowed();
    if (consent === false) { marker.dataset.rdFormDelivery = 'consent_denied'; remove(marker); return false; }
    if (consent !== true) { marker.dataset.rdFormDelivery = 'consent_pending'; return true; }
    try {
      const record = JSON.parse(win.sessionStorage.getItem(key(marker)) || 'null');
      if (!record || record.state !== 'pending') { marker.dataset.rdFormDelivery = record?.state === 'queued' ? 'queued' : 'no_submission'; return false; }
      if (!Number.isFinite(record.created)) { remove(marker); return false; }
      const age = Date.now() - record.created;
      if (age < 0 || age > maxAge || record.type !== marker.dataset.rdFormType ||
          record.path !== win.location.pathname) { remove(marker); return false; }
      if (!configured()) { marker.dataset.rdFormDelivery = 'waiting_for_official_tag'; return true; }
      // 先占用本次提交，避免重复模块、刷新和 section 重绘再次入队。
      win.sessionStorage.setItem(key(marker), JSON.stringify({...record, state: 'queued'}));
      try {
        win.gtag('event', 'roomden_form_success', {
          send_to: target,
          form_type: record.type,
          form_placement: marker.dataset.rdFormPlacement,
          page_location: win.location.origin + win.location.pathname
        });
      } catch (_) {
        win.sessionStorage.setItem(key(marker), JSON.stringify(record));
        return true;
      }
      marker.dataset.rdFormDelivery = 'queued';
      return false;
    } catch (_) { marker.dataset.rdFormDelivery = 'storage_unavailable'; return false; } // 存储不可用时不猜测一次性成功。
  }
  function flush() {
    timer = null;
    let waiting = false;
    for (const marker of markers) if (marker.isConnected) waiting = receive(marker) || waiting;
    if (waiting && ++attempts < 60) timer = win.setTimeout(flush, 1000);
  }
  function start() {
    if (timer !== null) win.clearTimeout(timer);
    attempts = 0;
    flush();
  }
  function scan() {
    ensurePrivacy();
    for (const marker of doc.querySelectorAll('[data-rd-form-receipt]')) {
      const type = marker.dataset.rdFormType;
      const form = marker.closest('form');
      if (!form || !types.has(type) || !marker.dataset.rdFormKey) continue;
      if (!bound.has(form)) {
        bound.add(form);
        // CAPTCHA可先preventDefault再原生提交；尝试本身不代表成功。
        form.addEventListener('submit', function () {
          if (allowed() !== true) { remove(marker); return; }
          try {
            win.sessionStorage.setItem(key(marker), JSON.stringify({
              type, path: win.location.pathname, created: Date.now(), state: 'pending'
            }));
          } catch (_) { /* 不影响真实提交。 */ }
        }, true);
      }
      if (marker.dataset.rdFormReceipt === 'success') markers.add(marker);
      else remove(marker);
    }
    if (markers.size) start();
  }
  doc.addEventListener('visitorConsentCollected', () => {
    if (allowed() === false) {
      for (const marker of doc.querySelectorAll('[data-rd-form-receipt]')) remove(marker);
    }
    if (markers.size) start();
  });
  doc.addEventListener('shopify:section:load', scan);
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', scan, {once:true});
  else scan();
});
